import { MutableRefObject, useEffect, useState } from "react";

export function useEditsChildWidth(parentRef: MutableRefObject<HTMLDivElement | null>) {
  const [isEditsCenter, setIsEditsCenter] = useState(false);
  const parentPadding = 32;

  function calculatePosition() {
    if (!parentRef.current) return;

    const parentDiv = parentRef?.current;
    const childrens = parentDiv.children;

    const gapBetweenChildInString = window
      .getComputedStyle(parentRef.current)
      .getPropertyValue("gap");
    const gap = Math.floor(
      Number(gapBetweenChildInString.slice(0, gapBetweenChildInString.length - 2)),
    );
    let childWidth = gap * childrens?.length - 1;

    Array.from(childrens).forEach((ele) => {
      childWidth += ele.scrollWidth;
    });

    if (childWidth > parentDiv.scrollWidth - parentPadding) setIsEditsCenter(false);
    else setIsEditsCenter(true);
  }

  useEffect(() => {
    calculatePosition();
    window.addEventListener("resize", calculatePosition);
    return () => {
      window.removeEventListener("resize", calculatePosition);
    };
  }, []);

  return { isEditsCenter };
}
